import {
  Button,
  CircularProgress,
  Divider,
  Typography,
} from "@suraasa/placebo-ui"
import NotificationBell from "assets/Fallback/notification-bell.svg"
import clsx from "clsx"
import Fallback from "components/Fallback"
import { context } from "global/Context/context"
import { useContext, useEffect } from "react"
import routes from "routes"
import { isShadow } from "utils/shadow"

import TabBar from "../../../components/TabBar"
import { useNotifications } from "../hooks/useNotifications"
import styles from "../Notifications.module.css"
import NotificationsList from "../NotificationsList"

const NotificationsPopup = () => {
  const [_, toggleMenu] = useContext(context).notificationsPopupMenuState
  const {
    tabs,
    notifications,
    markAllAsRead,
    changeTab,
    activeTab,
    getDescription,
    pageOverview,
  } = useNotifications({ useSearchParams: false, popup: true })
  const { isLoading: pageLoading, isError: pageError } = pageOverview
  const {
    data: notificationList,
    isFetching,
    isError,
    hasNextPage,
    fetchNextPage,
  } = notifications

  useEffect(() => {
    if (!isShadow()) markAllAsRead()
  }, [])

  if (pageLoading || pageError) {
    return (
      <Fallback
        data={{
          image: NotificationBell,
          title: "No Notifications!",
        }}
        isLoading={pageLoading}
        hasError={pageError}
        className="my-6"
      />
    )
  }

  return (
    <div className="relative">
      <div className="px-2">
        <div className="my-2">
          <Typography variant="title3">Notifications</Typography>
        </div>
      </div>
      <div className="px-2">
        <TabBar
          className="pt-1"
          activeTab={activeTab}
          tabs={tabs}
          onChange={changeTab}
        />
      </div>

      <Divider className={styles.divider} />

      <div className={clsx(styles.popup)}>
        {(isError ||
          notificationList?.pages[0].data.notifications.length == 0) && (
          <Fallback
            data={{
              image: NotificationBell,
              title: "No Notifications!",
              description: getDescription(),
            }}
            className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 px-2 text-center sm:w-fit sm:px-0"
            hasError={isError}
          />
        )}
        {notificationList && (
          <NotificationsList
            data={notificationList}
            loading={isFetching}
            hasNextPage={hasNextPage}
            actionFunc={fetchNextPage}
            mini
          />
        )}

        {isFetching && (
          <div className="flex h-full flex-col items-center justify-center py-5">
            <CircularProgress />
          </div>
        )}
      </div>

      <div className="w-full border-t border-onSurface-300 bg-white py-1 text-center">
        <a href={routes.notifications}>
          <Button variant="text">View All Notifications</Button>
        </a>
      </div>
    </div>
  )
}

export default NotificationsPopup
